module.exports = __webpack_public_path__ + "img/bg.2145f149.jpeg";